import { TLocation, ILocation } from 'shared/types/location';
import { getRegionId } from '../geo';
import {
  MOSCOW_AND_REGION_ID,
  MOSCOW_ID,
  MOSCOW_REGION_ID,
  SPB_AND_REGION_ID,
  SPB_ID,
  SPB_REGION_ID,
} from 'shared/constants/regions';

const METRO_MAP_REGIONS: Record<number, number> = {
  [MOSCOW_AND_REGION_ID]: MOSCOW_ID,
  [MOSCOW_REGION_ID]: MOSCOW_ID,
  [SPB_AND_REGION_ID]: SPB_ID,
  [SPB_REGION_ID]: SPB_ID,
};

export const getLocationIdForMetro = (location: TLocation) => {
  const regionId = getRegionId(location);

  return METRO_MAP_REGIONS[regionId] || (location as ILocation).id;
};
